import { useEffect, useRef, useState } from "react";
import Api from "../../service/http";

const NewChatModal = ({ onClose, onCreate }) => {
    const [name, setName] = useState("");
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const fileInputRef = useRef(null);

    // Escape key to close modal
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", handleEscape);
        return () => window.removeEventListener("keydown", handleEscape);
    }, [onClose]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleImageClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleCreate = async () => {
        if (!name.trim()) {
            alert("Chat name is required.");
            return;
        }

        if (!image) {
            alert("Image is required.");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("name", name);
            formData.append("image", image);

            const response = await Api.post("/web/chat", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.data.id) {
                onCreate();
                onClose();
            } else {
                alert("Failed to create chat");
            }
        } catch (error) {
            console.error("Error creating chat:", error);
            alert("Error creating chat");
        }
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            aria-modal="true"
            role="dialog"
        >
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                <h2 className="text-xl font-semibold mb-4 text-center">Create New Chat</h2>

                <div className="space-y-4">
                    {/* Image Placeholder */}
                    <div
                        onClick={handleImageClick}
                        className="w-32 h-32 mx-auto border rounded flex items-center justify-center cursor-pointer hover:ring-2 hover:ring-blue-400 transition"
                    >
                        {imagePreview ? (
                            <img
                                src={imagePreview}
                                alt="Selected"
                                className="w-full h-full object-cover rounded"
                            />
                        ) : (
                            <span className="text-gray-500 text-sm text-center">Click to upload image</span>
                        )}
                    </div>

                    {/* Hidden File Input */}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        ref={fileInputRef}
                        className="hidden"
                    />

                    <input
                        type="text"
                        name="name"
                        placeholder="Chat Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <button
                        onClick={handleCreate}
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
                    >
                        Create
                    </button>
                    <button
                        onClick={onClose}
                        className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewChatModal;
